import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../Redux/Store/index.ts";
import { Container, Row, Col, Form } from "react-bootstrap";
import SideBar from "../Components/SideBar.tsx";
import { Task } from "../lib/interface.ts";
import "./Home.css";
import "./ScadenziarioPage.css";
import { useNavigate } from "react-router-dom";
import ModalFormTaskSingolo from "../Components/ModalFormTaskSingolo.tsx";
import { Dropdown, FormControl } from "react-bootstrap";

const ScadenziarioPage: React.FC = () => {
  const task = useSelector((state: RootState) => state.task.task);
  const { profilo } = useSelector((state: RootState) => state.login);
  const { cantieri } = useSelector((state: RootState) => state.cantieri);
  const { eventi } = useSelector((state: RootState) => state.eventi);
  const navigate = useNavigate();
  const [assegnatoA, setAssegnatoA] = useState(profilo.id);
  const [arrayTaskUtente, setArrayTaskUtente] = useState<Task[]>(
    task.filter((task) => task.assegnatoA === profilo.id)
  );
  const dipendenti = useSelector(
    (state: RootState) => state.utenti.utenti || []
  );

  const [dipendenteSelezionato, setDipendenteSelezionato] = useState<string>(
    assegnatoA // se avevi un valore di default
  );

  const [searchTextDipendente, setSearchTextDipendente] = useState("");
  const [titolo, setTitolo] = useState("Le tue scadenze");
  const [arrayTaskOggi, setArrayTaskOggi] = useState<Task[]>([]);
  const [arrayTaskScaduti, setArrayTaskScaduti] = useState<Task[]>([]);
  const [arrayTaskDomani, setArrayTaskDomani] = useState<Task[]>([]);
  const [type, setType] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [taskModal, setTaskModal] = useState<Task>({
    id: "",
    titolo: "",
    descrizione: "",
    dataInizio: "",
    scadenza: "",
    dataFineEffettiva: "",
    priorita: "",
    promemoria: "",
    dataPromemoriaPersonalizzata: "",
    cantiereId: "",
    contrattoQuadroId: "",
    eventoId: "",
    assegnatoA: "",
    stato: "",
  });
  useEffect(() => {
    if (assegnatoA == profilo.id) {
      setTitolo("Le tue scadenze");
    } else {
      const dipendente = dipendenti.filter((d) => d.id == assegnatoA);
      if (dipendente.length > 0) {
        setTitolo(
          "Scandenze di " + dipendente[0]?.nome + " " + dipendente[0]?.cognome
        );
      }
    }
    const filteredTasks = task.filter((t) => t.assegnatoA === assegnatoA);
    setArrayTaskUtente(filteredTasks);
  }, [assegnatoA, task]);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]; // Solo la parte "YYYY-MM-DD"
    const tasksOggi = arrayTaskUtente.filter((t) => t.scadenza === today);
    const tasksScaduti = arrayTaskUtente.filter((t) => t.scadenza < today);
    const tasksDomani = arrayTaskUtente.filter((t) => t.scadenza > today);

    setArrayTaskOggi(tasksOggi);
    setArrayTaskScaduti(tasksScaduti);
    setArrayTaskDomani(tasksDomani);
  }, [arrayTaskUtente]);

  const renderTaskRow = (task: Task) => {
    console.log(task);
    console.log(task);

    let object;
    let nome;
    if (task.cantiereId) {
      object = cantieri.filter((cantiere) => cantiere.id == task.cantiereId);
      console.log(object[0].nome);
      nome = object[0].nome;
    }
    if (task.eventoId) {
      object = eventi.filter((evento) => evento.id == task.eventoId);
      nome = object[0].titolo;
    }
    if (!task.eventoId && !task.cantiereId) {
      nome = "-";
    }

    return (
      <Row
        key={task.id}
        className="py-2 align-items-center"
        style={{ cursor: "pointer" }}
        onClick={() => {
          setTaskModal(task); // Aggiorna i dati del task selezionato
          setType(
            task.cantiereId ? "cantiere" : task.eventoId ? "evento" : "singolo"
          );
          setModalOpen(true); // Apri il modal
        }}
      >
        <Col xs={3}>{task.titolo}</Col>
        <Col xs={2}>{new Date(task.scadenza).toLocaleDateString("it-IT")}</Col>
        <Col xs={2}>
          <span className={`badge ${getPriorityClass(task.priorita)}`}>
            {task.priorita}
          </span>
        </Col>
        <Col xs={2}>
          <span className={`badge ${getStatusClass(task.stato)}`}>
            {task.stato}
          </span>
        </Col>
        <Col xs={3}>{nome}</Col>
      </Row>
    );
  };

  const getPriorityClass = (priorita: string) => {
    switch (priorita.toLowerCase()) {
      case "alta":
        return "badge-alta";
      case "media":
        return "badge-media";
      case "bassa":
        return "badge-bassa";
      case "urgente":
        return "badge-urgente";
      default:
        return "badge-secondary";
    }
  };

  const getStatusClass = (stato: string) => {
    switch (stato.toLowerCase()) {
      case "in_corso":
        return "badge-in-corso";
      case "da_fare":
        return "badge-da-fare";
      case "completato":
        return "badge-completato";
      case "annullato":
        return "badge-annullato";
      default:
        return "badge-light";
    }
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-between"
      style={{ margin: "0", padding: "0" }}
    >
      <Container fluid style={{ margin: "0", padding: "0", width: "5%" }}>
        <SideBar />
      </Container>
      <Container fluid className="colonna-scadenziario">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="header-title mt-3">{titolo}</h2>
          <Form.Group className="mb-3 w-20">
            <Form.Label className="d-flex justify-content-center">
              Seleziona dipendente
            </Form.Label>

            <Dropdown>
              <Dropdown.Toggle
                variant="outline-secondary"
                className="w-100 input-crea-edit p-0 h-2r"
                id="dipendenteDropdown"
              >
                {/* Se hai un dipendente selezionato, mostra nome, altrimenti placeholder */}
                {dipendenti.find((d) => d.id === dipendenteSelezionato)
                  ? `${
                      dipendenti.find((d) => d.id === dipendenteSelezionato)
                        ?.nome
                    } ${
                      dipendenti.find((d) => d.id === dipendenteSelezionato)
                        ?.cognome
                    }`
                  : "Seleziona dipendente"}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{ maxHeight: "500px", width: "100%", overflowY: "auto" }}
              >
                {/* casella di testo in testa al menu per filtrare */}
                <FormControl
                  autoFocus
                  className="w-100"
                  placeholder="Filtra dipendente"
                  onChange={(e) => setSearchTextDipendente(e.target.value)}
                  value={searchTextDipendente}
                />
                <Dropdown.Divider />

                {dipendenti
                  .filter((dipendente) =>
                    `${dipendente.nome} ${dipendente.cognome}`
                      .toLowerCase()
                      .includes(searchTextDipendente.toLowerCase())
                  )
                  .map((dipendente, idx) => (
                    <Dropdown.Item
                      key={idx}
                      onClick={() => {
                        // aggiorna lo stato "assegnatoA" e "dipendenteSelezionato"
                        setAssegnatoA(dipendente.id);
                        setDipendenteSelezionato(dipendente.id);
                      }}
                    >
                      {`${dipendente.nome} ${dipendente.cognome}`}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
        </div>
        <section className="div-scadenziari">
          <h3>Scadute</h3>{" "}
          {arrayTaskScaduti.length > 0 ? (
            <>
              <Row className="py-2 fw-bold ">
                <Col xs={3}>Titolo</Col>
                <Col xs={2}>Scadenza</Col>
                <Col xs={2}>Priorità</Col>
                <Col xs={2}>Stato</Col>
                <Col xs={3}>Cantiere/Evento</Col>
              </Row>
              {arrayTaskScaduti.map(renderTaskRow)}
            </>
          ) : (
            <div className="d-flex justify-content-center align-item-center">
              {" "}
              Non ci sono task scaduti
            </div>
          )}
        </section>

        <section className="div-scadenziari">
          <h3>Oggi</h3>
          {arrayTaskOggi.length > 0 ? (
            <>
              <Row className="py-2 fw-bold ">
                <Col xs={3}>Titolo</Col>
                <Col xs={2}>Scadenza</Col>
                <Col xs={2}>Priorità</Col>
                <Col xs={2}>Stato</Col>
                <Col xs={3}>Cantiere/Evento</Col>
              </Row>
              arrayTaskOggi.map(renderTaskRow)
            </>
          ) : (
            <div className="d-flex justify-content-center align-item-center">
              {" "}
              Non ci sono task per oggi
            </div>
          )}
        </section>

        <section className="div-scadenziari">
          <h3>Prossimi giorni</h3>{" "}
          {arrayTaskDomani.length > 0 ? (
            <>
              <Row className="py-2 fw-bold ">
                <Col xs={3}>Titolo</Col>
                <Col xs={2}>Scadenza</Col>
                <Col xs={2}>Priorità</Col>
                <Col xs={2}>Stato</Col>
                <Col xs={3}>Cantiere/Evento</Col>
              </Row>
              {arrayTaskDomani.map(renderTaskRow)}
            </>
          ) : (
            <div className="d-flex justify-content-center align-item-center">
              {" "}
              Non ci sono task per i prossimi giorni
            </div>
          )}
        </section>
      </Container>
      <ModalFormTaskSingolo
        taskModal={taskModal}
        isModalOpen={isModalOpen}
        setModalOpen={setModalOpen}
        type={type}
        iscreate={false}
      />
    </Container>
  );
};

export default ScadenziarioPage;
